<template>
  <v-textarea
      v-model="inputVal"
      filled
      solo
      flat
      :auto-grow="autoGrow"
      background-color="#F7F7F7"
      :hide-details="hideDetails"
      :height="height"
      :counter="counter"
      :placeholder="placeholder"
      :readonly="readonly"
      :no-resize="noResize"
      :class="{'is-btns':isBtns}"
      :rows="rows"
      :maxlength="maxlength"
  >
    <template v-slot:append v-if="isBtns">
      <div class="btn-area">
        <v-file-input accept="image/*" @change="upload" hide-input hide-details class="btn-photo" tabindex="-1" @click="onCapture"></v-file-input>
        <v-btn v-if="isRecording" depressed plain @click="onRecord" class="btn-recording"><i></i>녹음</v-btn>
      </div>
    </template>
  </v-textarea>
</template>

<script>

import utils from '../../utils/utils.js'

export default {
  props: {
    maxlength: Number,
    value: String,
    height: {
      type: [String, Number]
    },
    counter: Number,
    placeholder: String,
    isBtns: Boolean,
    isRecording: Boolean,
    readonly: Boolean,
    beForePhotoNo: Number,
    autoGrow: {
      type: Boolean,
      default: false
    },
    noResize: {
      type: Boolean,
      default: true
    },
    rows: String
  },
  components: {},
  computed: {
    hideDetails() {
      return (this.counter > 0) ? false : true
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isAndroid () {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('android') >= 0) {
        return true
      } else {
        return false
      }
    }
  },
  data: () => ({
    file: '',
    fileId: '',
    beforeFileId: '',
    fileName: '',
    action: ''

  }),
  watch: {
    fileId() {
      if (this.fileId == 0) {
        this.$emit('photo', "error", "error")
      } else {
        this.$emit('photo', this.fileId, this.beforeFileId, this.fileName)
      }

    },
    beForePhotoNo() {
      this.beforeFileId = this.beForePhotoNo
    }
  },
  mounted() {
    this.beforeFileId = this.beForePhotoNo
  },
  methods: {
    onCapture (event) {
      if (this.isAndroid) {
        try {
          let success = window.AndroidInterface.checkSelfPermission('CAMERA')
          if (!success) event.preventDefault()
        } catch (e) {
          // 안드로이드 function 못찾은 거니까 그냥 진행하도록 함
        }
      }
    },
    onRecord () {
      if (this.isAndroid) {
        try {
          let success = window.AndroidInterface.checkSelfPermission('AUDIO')
          if (success) {
            this.$emit('recording')
          }
        } catch (e) {
          // 안드로이드 function 못찾은 거니까 그냥 진행하도록 함
          this.$emit('recording')
        }
      } else {
        this.$emit('recording')
      }

    },
    async upload(file) {

      this.fileId = -1 //임시번호 할당
      this.$emit('loading', true)

      this.file = file;
      var formData = new FormData();
      formData.append('file', this.file);
      formData.append('beforeFileId', this.beforeFileId);

      utils.File.fileUpload(formData
      ).then(response => {

        this.fileId = response.data.fileId
        this.beforeFileId = response.data.fileId
        this.fileName = response.data.fileName
      })
          .catch(() => {
            this.fileId = 0 // error 로 호출
          })
          .finally(() => {
            this.$emit('loading', false)
          })
    }

  }

}
</script>
<style lang="scss" scoped>
::v-deep.v-textarea {
  // font-size: 14px;
  .v-text-field__details {
    padding: 0;

    .v-counter {
      font-size: 14px;
      color: #BEBEBE;
      font-weight: 300;
    }
  }

  .btn-area {
    //position: absolute;
    //bottom: 0;
    //left: 0;
    width: 100%;
    height: 40px;
    display: flex;
    flex-grow: 1;
    background: #E9E6FF;
    border-radius: 0 0 6px 6px;

    .v-btn {
      flex: auto;
      font-size: 14px;
      color: #7260FF;
      border-radius: 0 0 0 6px;
      height: 40px;

      svg {
        margin-right: 5px;
      }
    }

    .btn-recording {
      position: relative;
      border-radius: 0 0 6px 0;

      i {
        display: inline-block;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: currentColor;
        margin-right: 5px;
      }

      &:after {
        position: absolute;
        content: '';
        display: inline-block;
        width: 1px;
        height: 20px;
        background: currentColor;
        left: 0;

      }
    }

    .btn-photo {
      justify-content: center;
      margin: 0;
      padding: 0;

      .v-input__prepend-outer {
        margin: 0;
        padding: 0;
        align-self: center;

        .v-input__icon {
          width: auto;

          .mdi-paperclip::before {
            content: '사진';
            font-family: 'Pretendard';
            font-size: 14px;
            font-weight: 500;
            color: #7260FF;
            padding-left: 25px;
            background: url("~@/assets/images/ic_photo.svg") 0 center no-repeat;
          }
        }
      }
    }
  }

  &.is-btns {
    .v-input__slot {
      flex-direction: column;
      //padding-bottom: 50px !important;
      .v-text-field__slot {
        padding-bottom: 5px;
      }
      .v-input__append-inner {
        width: calc(100% + 24px);
        padding: 0 !important;
        margin: 0 -12px !important;
      }
    }

  }
}
</style>
